/*
 * @FilePath: \kitchen-offline-web\src\3DEngine\components\renderBox.jsx
 * @Author: Yongchao Wang
 * @Date: 2021-07-19 20:41:31
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-06-09 14:27:50
 */
import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RenderEngine from '@/3DEngine/render/renderEngine';
// import loading3d from '../assets/3dloading.svg';
// import style from './renderBox.module.css';
// import Loading from '@/components/Loading/loading';
import Loading from '@/components/Loading/loading';
import CalloutCanvas from './calloutLineCanvas/calloutLines';

function RenderBox(props) {
  const { t } = useTranslation();
  const {
    width, height, initCallBack,
    showLoading, show,
  } = props;
  const [engine3D, setEngine3D] = useState(null);
  useEffect(() => {
    Loading.show();
    setTimeout(() => {
      const canvas = document.getElementById('renderCanvas');
      const engine = new RenderEngine(canvas);
      setEngine3D(engine);
      initCallBack({ engine });
      Loading.hide();
    }, 1000);
  }, []);
  useEffect(() => {
    const canvas = document.getElementById('renderCanvas');
    if (canvas.width !== width) {
      console.log('canvas.width');
      canvas.width = width * window.devicePixelRatio;
    }
    if (canvas.height !== width) {
      canvas.height = height * window.devicePixelRatio;
    }
  }, [width, height]);
  // const textHeight = document.body.clientWidth > 1023 ? 37 : 20;
  return (
    <>
      <div style={{
        display: show ? 'block' : 'none',
        width: `${width}px`,
        height: `${height}px`,
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 500ms',
      }}
      >
        <canvas
          id="renderCanvas"
          width={width * window.devicePixelRatio}
          height={height * window.devicePixelRatio}
          style={{ width: `${width}px`, height: `${height}px` }}
        />
        <CalloutCanvas
          width={width * window.devicePixelRatio}
          height={height * window.devicePixelRatio}
          style={{ width: `${width}px`, height: `${height}px` }}
          engine3D={engine3D}
        />
        <Loading
          width="100%"
          height="100%"
          message={t('other.modelLoading')}
          isShow={showLoading}
          type="localScreen"
        />
        {/* <div style={{
          width: `${width}px`,
          height: `${height}px`,
          position: 'absolute',
          left: 0,
          top: 0,
          backgroundColor: 'white',
          display: showLoading ? 'flex' : 'none',
          // display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        >
          <img
            style={{
              width: `${width * 0.4}px`,
              objectFit: 'contain',
            }}
            src={loading3d}
            alt=""
          />
          <div className={style['loading-text']}>模型加载中</div>
        </div> */}
      </div>
    </>
  );
}

RenderBox.propTypes = {
  show: propTypes.bool.isRequired,
  width: propTypes.number.isRequired,
  height: propTypes.number.isRequired,
  initCallBack: propTypes.func.isRequired,
  showLoading: propTypes.bool.isRequired,
};


export default RenderBox;
